/**
 * Every app built on app-core keeps its browser storage under its own prefix, so two apps on one
 * origin (local development, a shared host) never read each other's session or culture. The
 * default is Operations' historical prefix, which keeps its keys (`invite.ops.token`, …) unchanged.
 */
const DEFAULT_STORAGE_PREFIX = 'invite.ops';

let storagePrefix = DEFAULT_STORAGE_PREFIX;

export interface AppCoreOptions {
  storagePrefix: string;
}

/** Call once at app start, before anything reads storage (the token store reads on first use). */
export const configureAppCore = (opts: AppCoreOptions): void => {
  storagePrefix = opts.storagePrefix;
};

export const storageKey = (name: string): string => `${storagePrefix}.${name}`;
